export default __webpack_public_path__ + "static/media/Ies_Descripcion.bb8e626f.jpg";